import { render } from "./DepartmentsView.vue?vue&type=template&id=4b71af37&scoped=true"
import script from "./DepartmentsView.vue?vue&type=script&lang=js"
export * from "./DepartmentsView.vue?vue&type=script&lang=js"

import "./DepartmentsView.vue?vue&type=style&index=0&id=4b71af37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b71af37"]])

export default __exports__